import React, { useState, useEffect } from 'react'
import { useDispatch } from 'react-redux';
import { Grid } from '@mui/material';

import PharmaorderPageRootHolder from './PharmaorderPageRootHolder';

import { openDrawer } from './../../../store/slice/MenuSlice';

export default function PharmaorderPage() {
    const dispatch = useDispatch();
    useEffect(() => {
       // dispatch(openDrawer({drawerOpen: true}));
    },[]);

    return (
        < PharmaorderPageRootHolder />
    )

}